$(document).ready(function () {
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this)
                .parents(".js-href-teleport-wrapper")
                .find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : "_self";

        if (href) {
            $(this).wrapInner(
                '<a href="' + href + '" target="' + target + '"></a>',
            );
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent")
        .delegate("a", "click", function (e) {
            var target = $(this).attr("target"),
                url = $(this).attr("href");

            if (target == "_blank") {
                window.open(url);
            } else {
                window.location = url;
            }
            return false;
        })
        .click(function () {
            var target = $(this).find("a.js-click-item-link").attr("target"),
                url = $(this).find("a.js-click-item-link").attr("href");

            if (target == "_blank") {
                window.open(url);
            } else {
                window.location = url;
            }
            return false;
        });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();

        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if (
                elementTop + offset <= viewPortEnd &&
                elementBottom - offset >= viewPortStart
            ) {
                var delay = $(this).data("animation-delay");
                $(this)
                    .css("transition-delay", delay + "s")
                    .addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $("a:not([data-targetblank=ignore])").each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr("target", "_blank");
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-navmobile").toggleClass("active");
        $("body").toggleClass("freeze");
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderCard
    // *
    // *
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderCard (Optimiert)
    // *
    // *
    var $sliderCards = $(".js-slidercard");

    if ($sliderCards.length) {
        $sliderCards.each(function () {
            var $slider = $(this);
            var isTickerMode = true;

            $slider.slick({
                variableWidth: true,
                infinite: true,
                arrows: false,
                dots: false,
                swipeToSlide: true,
                touchThreshold: 20, // Leicht erhöht, damit er auf Mobile noch williger reagiert
                waitForAnimate: false,

                // Ticker Start-Modus
                autoplay: true,
                autoplaySpeed: 0,
                speed: 8000,
                cssEase: "linear",
                pauseOnHover: false,
                pauseOnFocus: false,
            });

            var isDragging = false;
            var startPos = { x: 0, y: 0 };

            // Modus-Wechsel sofort beim allerersten Berühren auslösen, nicht erst beim Bewegen!
            $slider.on("mousedown touchstart", function (e) {
                var evt =
                    e.type === "touchstart" ? e.originalEvent.touches[0] : e;
                startPos = { x: evt.pageX, y: evt.pageY };
                isDragging = false;

                // Ticker sofort stoppen und auf nativen Snap-Modus umbauen,
                // bevor der Finger wirklich anfängt zu ziehen
                if (isTickerMode) {
                    isTickerMode = false;

                    // Wir pausieren sofort hart, um das DOM zu stabilisieren
                    $slider.slick("slickPause");

                    // Setzen die neuen Optionen (ohne UI-Refresh zu erzwingen, da false)
                    $slider.slick(
                        "slickSetOption",
                        "autoplaySpeed",
                        3000,
                        false,
                    );
                    $slider.slick("slickSetOption", "speed", 400, false); // 400ms fühlt sich snappier an als 600ms
                    $slider.slick(
                        "slickSetOption",
                        "pauseOnHover",
                        true,
                        false,
                    );
                    $slider.slick("slickSetOption", "cssEase", "ease", false);

                    // Starten den Slider im neuen Modus neu
                    $slider.slick("slickPlay");
                }
            });

            // Bewegung nur tracken, um zu wissen, ob am Ende ein Klick erlaubt ist
            // Kein Ausführen von schweren Funktionen hier!
            $slider.on("mousemove touchmove", function (e) {
                var evt =
                    e.type === "touchmove" ? e.originalEvent.touches[0] : e;

                if (
                    Math.abs(evt.pageX - startPos.x) > 10 ||
                    Math.abs(evt.pageY - startPos.y) > 10
                ) {
                    isDragging = true;
                }
            });

            // Klick-Verhalten steuern
            $slider.find("a").on("click", function (e) {
                if (isDragging) {
                    e.preventDefault();
                }
                setTimeout(function () {
                    isDragging = false;
                }, 50);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this)
                .find(".js-hero-slider-track")
                .slick({
                    fade: true,
                    infinite: true,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    speed: 1000,
                    waitForAnimate: false,
                    dots: false,
                    pauseOnHover: false,
                    prevArrow: $(this).find(".js-pagination-prev"),
                    nextArrow: $(this).find(".js-pagination-next"),
                    responsive: [
                        {
                            breakpoint: 768, // Ab Tablet/Smartphone abwärts
                            settings: {
                                fade: false, // Hier zwingend false für direktes Touch-Feedback!
                                speed: 400, // Schnellerer Übergang auf Mobile
                            },
                        },
                    ],
                });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * maxMediaSlider
    // *
    // *
    var $maxMediaSlider = $(".js-maxmedia-slider");

    if ($maxMediaSlider.length) {
        $maxMediaSlider.each(function () {
            $(this)
                .find(".js-maxmedia-slider-track")
                .slick({
                    fade: true,
                    infinite: true,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    speed: 1000,
                    waitForAnimate: false,
                    dots: false,
                    pauseOnHover: false,
                    prevArrow: $(this).find(".js-pagination-prev"),
                    nextArrow: $(this).find(".js-pagination-next"),
                    responsive: [
                        {
                            breakpoint: 768, // Ab Tablet/Smartphone abwärts
                            settings: {
                                fade: false, // Hier zwingend false für direktes Touch-Feedback!
                                speed: 400, // Schnellerer Übergang auf Mobile
                            },
                        },
                    ],
                });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this)
                .find(".js-content-slider-track")
                .slick({
                    fade: false,
                    infinite: true,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 2500,
                    speed: 1000,
                    waitForAnimate: true,
                    dots: true,
                    pauseOnHover: false,
                    appendDots: $(this).find(".js-content-slider-dots"),
                    prevArrow: $(this).find(".js-content-slider-prev"),
                    nextArrow: $(this).find(".js-content-slider-next"),
                });

            $(this).on(
                "init reInit afterChange",
                function (event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + 1;
                    $(this).find(".js-content-slider-count").text(i);
                },
            );
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this)
            .parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: "smooth" });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split("#")[1];
        if (
            hash &&
            $("#" + hash).hasClass("js-accordion-button") &&
            $("#" + hash)
                .siblings(".js-accordion-content")
                .attr("aria-expanded") !== "true"
        ) {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on("hashchange", function () {
        openAccordionFromHash();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem("dialogState");

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        sessionStorage.setItem("dialogState", true);
        $(this).parents(".js-dialog").get(0).close();
        $("body").removeClass("freeze");
    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            sessionStorage.setItem("dialogState", true);
            $(this).get(0).close();
            $("body").removeClass("freeze");
        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * shareButton
    // *
    // *
    $(".js-sharebutton").on("click", async function (e) {
        e.preventDefault(); // Verhindert unerwünschtes Scrollen, falls der Button in einem Formular oder Link liegt

        const $this = $(this);

        // Daten aus den HTML-Attributen auslesen (mit Fallback auf aktuelle Seite)
        const shareData = {
            title: $this.data("title") || document.title,
            text: $this.data("text") || "",
            url: $this.data("url") || window.location.href,
        };

        // 1. Prüfen: Unterstützt der Browser die native Share API?
        if (navigator.share) {
            try {
                await navigator.share(shareData);
                // Optional: Hier könntest du ein Analytics-Event feuern
                // console.log('Erfolgreich geteilt');
            } catch (error) {
                // Wird auch gefeuert, wenn der User den Teilen-Dialog einfach abbricht
                // console.log('Teilen abgebrochen oder fehlgeschlagen:', error);
            }
        } else {
            // 2. Fallback für Desktop-Browser, die die Share API nicht unterstützen
            navigator.clipboard
                .writeText(shareData.url)
                .then(function () {
                    // Hier idealerweise ein kleines Tooltip oder Toast-Notification anzeigen
                    alert("Link wurde in die Zwischenablage kopiert!");
                })
                .catch(function (err) {
                    console.error("Fehler beim Kopieren:", err);
                });
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * minicart
    // *
    // *
    $(".js-minicart-open").click(function () {
        showMiniCart();
    });

    $(".js-minicart-close").click(function () {
        hideMiniCart();
    });

    // close miniCart whenever user clicks outside minicart aside
    $(".js-minicart").on("click", function (e) {
        if ($(e.target).closest(".js-minicart-inner").length > 0) return; // Ignore click if click is inside minicart

        hideMiniCart();
    });

    function showMiniCart(showBadge = false) {
        $(".js-minicart").addClass("active");
        $(".js-minicart-badge").removeClass("active");

        if (showBadge) $(".js-minicart-badge").addClass("active");

        loadMiniCartProducts();
    }

    function hideMiniCart() {
        $(".js-minicart").removeClass("active");
        $(".js-minicart-badge").removeClass("active");
    }

    function loadMiniCartProducts() {
        $.ajax({
            url: "/assets/components/site/connector.php?action=getcart",
            type: "GET",
            data: {},
            success: function (response) {
                //console.log("Server antwortet:", response);

                // set products content
                $(".js-minicart-products").html(response.data.output);
                $(".js-minicart-total").html(response.data.total_formatted);

                if (response.data.total_quantity <= 0) {
                    $(".js-minicart, .js-header-cartnumber").addClass("empty");
                } else {
                    $(".js-minicart, .js-header-cartnumber").removeClass(
                        "empty",
                    );
                }
            },
            error: function (xhr) {
                console.error("Error:", xhr.responseText);
            },
        });
    }

    function updateMiniCartProduct(productId, quantity) {
        $.ajax({
            url: "/assets/components/site/connector.php?action=updatecartitem",
            type: "GET",
            data: { id: productId, quantity: quantity },
            success: function (response) {
                //console.log("Server antwortet:", response);

                // set data
                $(".js-header-cartnumber").html(
                    response.data.order.total_quantity,
                );

                if (response.data.order.total_quantity <= 0) {
                    $(".js-header-cartnumber").addClass("empty");
                } else {
                    $(".js-header-cartnumber").removeClass("empty");
                }

                // update cart
                loadMiniCartProducts();
            },
            error: function (xhr) {
                console.error("Error:", xhr.responseText);
            },
        });
    }

    // change quantity of an cart item
    $(document).on("change", ".js-minicart-quantity", function () {
        var productId = $(this).data("product"),
            quantity = $(this).val();

        updateMiniCartProduct(productId, quantity);
    });

    // change quantity of a cart item via stepper (+ / -)
    $(document).on(
        "click",
        ".js-minicart-stepper-dec, .js-minicart-stepper-inc",
        function () {
            var $btn = $(this),
                $stepper = $btn.closest(".js-minicart-stepper"),
                productId = $stepper.data("product"),
                $val = $stepper.find(".js-minicart-stepper-val"),
                currentQty = parseInt($val.text()) || 1,
                dir = $btn.hasClass("js-minicart-stepper-dec") ? -1 : 1,
                newQty = Math.max(0, currentQty + dir);

            updateMiniCartProduct(productId, newQty);
        },
    );

    // remove item from cart
    $(document).on("click", ".js-minicart-remove", function () {
        var productId = $(this).data("product");

        updateMiniCartProduct(productId, 0);
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add to cart
    // *
    // *
    $(".js-addtocart-form").on("submit", function (e) {
        e.preventDefault();

        let formData = new FormData(this);

        $.ajax({
            url: "/assets/components/site/connector.php?action=addtocart",
            type: "POST",
            data: formData,
            processData: false, // muss bei FormData auf false
            contentType: false, // darf NICHT gesetzt werden
            success: function (response) {
                //console.log("Server antwortet:", response);

                // set data
                $(".js-minicart-cartlink").attr("href", response.data.url);
                $(".js-header-cartnumber").html(response.data.total_quantity);

                if (response.data.total_quantity <= 0) {
                    $(".js-header-cartnumber").addClass("empty");
                } else {
                    $(".js-header-cartnumber").removeClass("empty");
                }

                // show minicart
                showMiniCart(true);
            },
            error: function (xhr) {
                console.error("Error:", xhr.responseText);
            },
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * stepper
    // *
    // *
    $(document).on("click", ".js-stepper-dec, .js-stepper-inc", function () {
        const $btn = $(this);
        const $stepper = $btn.closest(".js-stepper");
        const $val = $stepper.find(".js-stepper-val");
        const min = parseInt($stepper.data("min") ?? 1);
        const dir = $btn.hasClass("js-stepper-dec") ? -1 : 1;

        let val = parseInt($val.text()) + dir;
        val = Math.max(min, val);

        $val.text(val);
        $stepper.closest("form").find(".js-stepper-input").val(val);
        $stepper.find(".js-stepper-dec").prop("disabled", val <= min);
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * variant price update
    // *
    // *
    $(document).on("change", ".product__radio", function () {
        var price = $(this).data("price");
        if (price) {
            $(".js-product-price").html(price + " EUR");
        }
    });

    // Initialize price based on selected variant on load
    if ($(".product__radio:checked").length) {
        $(".product__radio:checked").trigger("change");
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animations for def context
    // *
    // *
    $(function () {
        // Sicherheits-Check: Nur im richtigen MODX-Kontext ausführen
        if ($("body").hasClass("site-web")) return;

        // Ziele definieren
        var $targets = $(
            ".headlineText, .introText__headline, .quote__wrapper, .hCategory, .form__wrapper, .quote, .quote__author, .imageText, .textBlock, .bannerContent__content, .introText .content, .textColumns__columns, .logoWall, .sliderCard__slider",
        ).not(".textColumns .introText__headline");

        var observer = new IntersectionObserver(
            function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        $(entry.target).addClass("is-visible");
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                rootMargin: "0px 0px -10% 0px",
                threshold: 0,
            },
        );

        // Observer auf alle Elemente anwenden
        $targets.each(function () {
            observer.observe(this);
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * filter team repeater
    // *
    // *
    (function () {
        const items = document.querySelectorAll(".js-team-item");
        const filterList = document.querySelector(".js-dynamic-filter-list");
        const clearBtn = document.querySelector(".js-team-clear");

        if (!items.length || !filterList) return;

        // 1. Kategorien und Labels sicher auslesen
        const categories = new Map();

        items.forEach((item) => {
            const catSlug = item.getAttribute("data-category");
            const catLabel = item.getAttribute("data-label");

            if (catSlug && catLabel) {
                // Die Map überschreibt eventuelle Duplikate automatisch anhand des Slugs
                categories.set(catSlug, catLabel);
            }
        });

        // 2. Buttons dynamisch mit den echten Labels generieren
        categories.forEach((label, slug) => {
            const li = document.createElement("li");
            li.className = "filter js-team-filter";
            li.setAttribute("data-filter", slug);
            li.textContent = label; // Hier landet exakt die Schreibweise aus dem Backend!

            filterList.appendChild(li);
        });

        // 3. Filter-Logik
        const filterBtns = document.querySelectorAll(".js-team-filter");

        filterBtns.forEach((btn) => {
            btn.addEventListener("click", () => {
                const selectedFilter = btn.getAttribute("data-filter");

                // Aktiven State setzen
                filterBtns.forEach((b) => b.classList.remove("is-active"));
                btn.classList.add("is-active");

                // Clear-Button einblenden
                if (clearBtn) clearBtn.style.display = "";

                // Items filtern (über CSS display)
                items.forEach((item) => {
                    if (item.getAttribute("data-category") === selectedFilter) {
                        item.style.display = ""; // Zeigen
                    } else {
                        item.style.display = "none"; // Verstecken
                    }
                });
            });
        });

        // 4. Clear-Logik
        if (clearBtn) {
            clearBtn.addEventListener("click", () => {
                filterBtns.forEach((b) => b.classList.remove("is-active"));
                clearBtn.style.display = "none";

                // Alle Items wieder anzeigen
                items.forEach((item) => {
                    item.style.display = "";
                });
            });
        }
    })();



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * countdown
    // *
    // *
    var $countdowns = $(".js-countdown");
 
    if ($countdowns.length) {
        $countdowns.each(function () {

 
            var $countdown = $(this);
 
            // MODX liefert "2026-09-24 11:00:00" -> Leerzeichen durch "T" ersetzen,
            // damit das Datum in allen Browsern (auch Safari) sicher geparst wird
            var raw = $countdown.find("[data-countdown-target]").attr("data-countdown-target").trim();
            var target = new Date(raw.replace(" ", "T")).getTime();
 
            var $days = $countdown.find("#countdown-days");
            var $hours = $countdown.find("#countdown-hours");
            var $minutes = $countdown.find("#countdown-minutes");
            var $seconds = $countdown.find("#countdown-seconds");
 
            var timer;
 
            function pad(num) {
                return String(num).padStart(2, "0");
            }
 
            function updateCountdown() {
                if (isNaN(target)) {
                    console.error("Countdown: Datum konnte nicht gelesen werden ->", raw);
                    clearInterval(timer);
                    return;
                }
 
                var diff = target - Date.now();
 
                if (diff <= 0) {
                    $days.text("00");
                    $hours.text("00");
                    $minutes.text("00");
                    $seconds.text("00");
                    clearInterval(timer);
                    return;
                }
 
                var days = Math.floor(diff / (1000 * 60 * 60 * 24));
                var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
                var minutes = Math.floor((diff / (1000 * 60)) % 60);
                var seconds = Math.floor((diff / 1000) % 60);
 
                $days.text(pad(days));
                $hours.text(pad(hours));
                $minutes.text(pad(minutes));
                $seconds.text(pad(seconds));
            }
 
            updateCountdown();
            timer = setInterval(updateCountdown, 1000);
 
        });
    }



});

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * DOM Teaser Filter (Statisch)
// *
// *
(function () {
    const filterBtns = document.querySelectorAll(".js-dom-filter-btn");
    const items = document.querySelectorAll(".js-dom-filter-item");
    const clearBtn = document.querySelector(".js-dom-filter-clear");

    if (!items.length || !filterBtns.length) return;

    filterBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            // Direkter Abgleich der Werte, kein String-Zusammenbau mehr
            const selectedFilter = btn.getAttribute("data-filter");

            // Aktiven State setzen
            filterBtns.forEach((b) => b.classList.remove("is-active"));
            btn.classList.add("is-active");

            // Clear-Button einblenden
            if (clearBtn) clearBtn.style.display = "";

            // Items filtern
            items.forEach((item) => {
                if (item.getAttribute("data-category") === selectedFilter) {
                    item.style.display = "";
                } else {
                    item.style.display = "none";
                }
            });
        });
    });

    // Clear-Logik
    if (clearBtn) {
        clearBtn.addEventListener("click", () => {
            filterBtns.forEach((b) => b.classList.remove("is-active"));
            clearBtn.style.display = "none";

            // Alle Items wieder anzeigen
            items.forEach((item) => {
                item.style.display = "";
            });
        });
    }
})();

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * scrolled Header
// *
// *
let lastScrollTop = 0;
const delta = 5; // Toleranzbereich: Erst ab 5px Scrollweg reagieren
const $header = $(".js-header");

$(window).on("load scroll", function () {
    let currentScroll = $(this).scrollTop();

    // Verhindert Fehler beim "Rubberband"-Scrolling auf Mac/iOS
    if (currentScroll < 0) {
        currentScroll = 0;
    }

    // NEU: Wenn die Bewegung kleiner als das Delta ist, sofort abbrechen!
    // Verhindert Flackern bei Mikrobewegungen und Stillstand.
    if (Math.abs(lastScrollTop - currentScroll) <= delta) {
        return;
    }

    if (currentScroll < 75) {
        // Regel 1: Innerhalb der ersten 75px die Klasse IMMER entfernen
        $header.removeClass("scrolled");
    } else {
        // Regel 2: Wir sind ab 75px abwärts – jetzt entscheidet die Richtung
        if (currentScroll > lastScrollTop) {
            // Wir scrollen nach unten
            $header.addClass("scrolled");
        } else if (currentScroll < lastScrollTop) {
            // NEU: Wir scrollen WIRKLICH nach oben (explizite Prüfung!)
            $header.removeClass("scrolled");
        }
    }

    // Aktuelle Position für den nächsten Aufruf speichern
    lastScrollTop = currentScroll;
});

if ($(".js-header-sticky").length) {
    $(window).on("load scroll", function () {
        if ($(window).scrollTop() >= 40) {
            $(".js-header-sticky").addClass("sticky");
        } else {
            $(".js-header-sticky").removeClass("sticky");
        }
    });
}

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * gallery in teaser card module
// *
// *
// Globale Funktion, die jederzeit (auch vom Vanilla JS) aufgerufen werden kann
window.initTeaserGalleries = function (container) {
    // Wenn kein spezifischer Container übergeben wird, durchsuche das ganze Dokument
    const $scope = container ? $(container) : $(document);

    // WICHTIG: Suche nur nach Galerien, die noch NICHT initialisiert wurden!
    $scope
        .find(".js-teasercard-gallery:not(.is-initialized)")
        .each(function () {
            const $gallery = $(this);
            const $images = $gallery.find(".js-teasercard-image");

            // Sofort markieren, damit diese Galerie beim nächsten AJAX-Call ignoriert wird
            $gallery.addClass("is-initialized");

            if ($images.length <= 1) {
                return;
            }

            let currentIndex = 0;
            $images.hide().eq(currentIndex).show();

            // Interval an diese spezifische Galerie hängen
            setInterval(function () {
                $images.eq(currentIndex).hide();
                currentIndex = (currentIndex + 1) % $images.length;
                $images.eq(currentIndex).show();
            }, 1000);
        });
};

// Initialer Aufruf beim allerersten Seitenladen
$(document).ready(function () {
    initTeaserGalleries();
});

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * filterResources
// *
// *
document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector(".js-teaser-container");
    const loadMoreBtn = document.querySelector(".js-loadmore");
    const filterItems = document.querySelectorAll(".js-filter");
    const clearBtn = document.querySelector(".js-ajax-clear");

    // NEU: Strenge Trennung von Lade-Schritt (4) und Initial-Wert (z.B. 10)
    const stepLimit = loadMoreBtn
        ? parseInt(loadMoreBtn.getAttribute("data-limit"), 10) || 4
        : 4;
    const initialOffset = loadMoreBtn
        ? parseInt(loadMoreBtn.getAttribute("data-initial-offset"), 10) ||
          stepLimit
        : stepLimit;

    let currentFormat = "";

    // NEU: Wir starten exakt bei der Zahl der bereits gerenderten Beiträge!
    let currentOffset = initialOffset;

    const ajaxEndpoint = "/ajax-teaser/";
    const parentId = loadMoreBtn
        ? loadMoreBtn.getAttribute("data-parent")
        : "0";

    function updateButtonVisibility(totalCount, currentLoadedCount) {
        if (!loadMoreBtn) return;

        if (totalCount <= currentLoadedCount) {
            loadMoreBtn.style.display = "none";
        } else {
            loadMoreBtn.style.display = "block";
        }
    }

    if (container && loadMoreBtn) {
        const initialTotal =
            parseInt(container.getAttribute("data-initial-total"), 10) || 0;
        updateButtonVisibility(initialTotal, initialOffset);
    }

    async function fetchTeasers(append = false) {
        if (!loadMoreBtn) return;
        loadMoreBtn.disabled = true;

        // LOGIK-SCHLÜSSEL:
        // Beim Load More (append) holen wir 'stepLimit' (4) neue.
        // Beim Filtern (neu laden) holen wir 'initialOffset' (10) neue.
        const currentLimit = append ? stepLimit : initialOffset;

        const url = `${ajaxEndpoint}?format=${currentFormat}&offset=${currentOffset}&parent=${parentId}&limit=${currentLimit}`;

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Netzwerkfehler");

            const rawHtml = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(rawHtml, "text/html");
            const metaEl = doc.querySelector(".js-ajax-meta");

            const totalCount = metaEl
                ? parseInt(metaEl.getAttribute("data-total"), 10)
                : 0;
            if (metaEl) metaEl.remove();

            const cleanHtml = doc.body.innerHTML;

            if (append) {
                container.insertAdjacentHTML("beforeend", cleanHtml);
                currentOffset += currentLimit; // Offset um 4 erhöhen
            } else {
                container.innerHTML = cleanHtml;
                currentOffset = currentLimit; // Nach dem Filtern steht der nächste Offset wieder auf 10
            }

            if (typeof window.initTeaserGalleries === "function") {
                window.initTeaserGalleries(container);
            }

            const currentlyRendered = append ? currentOffset : currentLimit;
            updateButtonVisibility(totalCount, currentlyRendered);
        } catch (error) {
            console.error("Fehler beim AJAX-Load:", error);
        } finally {
            loadMoreBtn.disabled = false;
        }
    }

    // Event-Listener für Filter
    filterItems.forEach((item) => {
        item.addEventListener("click", () => {
            filterItems.forEach((i) => i.classList.remove("is-active"));
            item.classList.add("is-active");

            currentFormat = item.getAttribute("data-format") || "";
            currentOffset = 0; // Wir starten beim Filtern immer bei der ersten Seite

            if (clearBtn) clearBtn.style.display = "";

            fetchTeasers(false);
        });
    });

    // Event-Listener für Load More
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener("click", () => {
            fetchTeasers(true);
        });
    }

    // 2. Fix für den Clear Button
    if (clearBtn) {
        clearBtn.addEventListener("click", (e) => {
            e.preventDefault(); // Verhindert ungewolltes Scrollen oder Neuladen

            // 1. Optisches Feedback zurücksetzen
            filterItems.forEach((i) => i.classList.remove("is-active"));

            // 2. Zustand zurücksetzen (genau dein Gedanke!)
            currentFormat = "";
            currentOffset = 0;

            clearBtn.style.display = "none";

            // 3. Neue Daten vom Server holen und DOM leeren
            fetchTeasers(false);
        });
    }
});

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * stickyButtons
// *
// *
$(window).on("scroll", function () {
    // Puffer von 50px, damit die Animation kurz vor dem absoluten Anschlag startet
    if (
        $(window).scrollTop() + $(window).height() >=
        $(document).height() - 100
    ) {
        $(".stickyButtons").addClass("bottom");
    } else {
        $(".stickyButtons").removeClass("bottom");
    }
});

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * consentNoticeSpacer
// *
// * Reserves space at the end of the footer while the consent notice
// * is visible, so it does not cover the Impressum/Datenschutz links
// *
(function () {
    var $spacer = $('<div class="consentNoticeSpacer" aria-hidden="true"></div>');

    function update() {
        var notice = document.getElementById("klaro-cookie-notice"),
            visible =
                notice &&
                !notice.classList.contains("cookie-notice-hidden") &&
                notice.offsetHeight > 0;

        $spacer.css(
            "height",
            visible ? window.innerHeight - notice.getBoundingClientRect().top : 0,
        );
    }

    $(function () {
        $("footer").last().append($spacer);
        update();
        new MutationObserver(update).observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["class"],
        });
        $(window).on("resize", update);
    });
})();
